var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBootstrap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "120px",
    height: "120px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-12.8,-12.8) scale(1.1,1.1)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.4608,6.33173) scale(8.53333,8.53333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.576,6.133c-0.051,-1.496 1.084,-2.875 2.618,-2.875h15.721c1.534,0 2.669,1.379 2.619,2.875c-0.049,1.437 0.015,3.298 0.471,4.816c0.458,1.522 1.229,2.485 2.494,2.608v1.402c-1.264,0.124 -2.036,1.086 -2.494,2.608c-0.456,1.518 -0.52,3.379 -0.471,4.816c0.051,1.496 -1.084,2.875 -2.619,2.875h-15.721c-1.534,0 -2.669,-1.379 -2.619,-2.875c0.049,-1.437 -0.015,-3.298 -0.471,-4.816c-0.458,-1.522 -1.231,-2.485 -2.495,-2.608v-1.402c1.264,-0.124 2.038,-1.086 2.495,-2.608c0.457,-1.518 0.52,-3.379 0.472,-4.816z",
    fill: "#f4f4f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.759,13.922v-0.017c1.168,-0.202 2.079,-1.296 2.079,-2.502c0,-0.852 -0.328,-1.574 -0.948,-2.087c-0.618,-0.512 -1.486,-0.782 -2.509,-0.782h-4.687v11.449h4.711c1.224,0 2.24,-0.299 2.938,-0.865c0.699,-0.567 1.069,-1.391 1.069,-2.384c0.001,-1.501 -1.065,-2.628 -2.653,-2.812zM14.564,13.383h-2.004v-3.351h2.385c1.308,0 2.029,0.574 2.029,1.616c-0.001,1.118 -0.856,1.735 -2.41,1.735zM12.56,14.786h2.369c1.711,0 2.579,0.618 2.579,1.838c0,1.218 -0.855,1.861 -2.474,1.861h-2.474z",
    fill: "#000001"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBootstrap);
export default __webpack_public_path__ + "static/media/bootstrap.7907b1fa7accd888167d0cfeae23251d.svg";
export { ForwardRef as ReactComponent };